export const tr = {
    'default-header-description': 'Dahili reklam ürünleri',
    'default-title': 'Ürün listesi',
    description: 'Description of the product list (ask editor)',
    'error-text': 'Try refreshing the page',
    'error-title': 'Hata oluştu',
    loading: 'Yükleniyor...',
    'marketers-header-description': 'Dahili reklam ürünleri yönetimi',
    'marketers-title': '\tÜrün yönetimi',
    title: 'Product list'
};
